export default __webpack_public_path__ + "static/media/vendedores.95d11538.png";